import { Sidebar as WdsSidebar } from "@datamole/wds-component-sidebar";
import { clsx } from "clsx";
import { useMemo } from "react";

import { Header } from "@/components/shared/app-layout/sidebar/header";
import { QuickLinksMenu } from "@/components/shared/app-layout/sidebar/quick-links-menu";
import { ReleaseNotes } from "@/components/shared/app-layout/sidebar/release-notes/release-notes";
import { SidebarItem } from "@/components/shared/app-layout/sidebar/sidebar-item";
import { CollapsibleSidebarItem } from "@/components/shared/app-layout/sidebar/sidebar-item/collapsible-sidebar-item";
import { createAgentsSubitems, sidebarItems } from "@/components/shared/app-layout/sidebar/sidebar-items";
import styles from "@/components/shared/app-layout/sidebar/sidebar.module.css";
import { useScrollToSectionEffect } from "@/components/shared/app-layout/sidebar/use-scroll-to-section-effect";
import { UserMenu } from "@/components/shared/app-layout/sidebar/user-menu/user-menu";
import { useLayoutSidebar } from "@/hooks/use-layout-sidebar";
import { useGetAgentsQuery } from "@/store/services/agent.service";

export const Sidebar = () => {
    const { isCollapsed: isSidebarCollapsed, toggle: toggleSidebar } = useLayoutSidebar();
    const { data: agents = [], error: agentsError, isLoading: isAgentsLoading } = useGetAgentsQuery();

    const agentsSubitems = useMemo(() => createAgentsSubitems(agents), [agents]);

    if (agentsError) {
        // TODO: handle error properly
        console.error("Failed to fetch agents", agentsError);
    }

    useScrollToSectionEffect();

    return (
        <WdsSidebar className={clsx(styles.sidebar, { [styles.collapsed]: isSidebarCollapsed })}>
            <WdsSidebar.Content>
                <Header sidebarCollapsed={isSidebarCollapsed} toggleSidebarCollapsed={toggleSidebar} />

                <SidebarItem {...sidebarItems.home} />

                <CollapsibleSidebarItem
                    subitems={agentsSubitems}
                    {...sidebarItems.agents}
                    isSubitemsLoading={isAgentsLoading}
                    isSidebarCollapsed={isSidebarCollapsed}
                    isInitiallyExpanded={true}
                />

                <SidebarItem {...sidebarItems.chatHistory} />

                <SidebarItem {...sidebarItems.scientificTesting} />

                <SidebarItem {...sidebarItems.trialEvents} />
            </WdsSidebar.Content>
            <WdsSidebar.Content className={styles.sidebar_footer}>
                <QuickLinksMenu />
                <ReleaseNotes />
                <UserMenu />
            </WdsSidebar.Content>
        </WdsSidebar>
    );
};
